<template>
  <AuthBox>
    <h1 class="auth-title">{{ $t('content.reset_title') }}</h1>
    <div class="auth-subtitle mb-6">{{ $t('content.reset_subtitle') }}</div>
    <form @submit.prevent="submit" autocomplete="off">
      <form-group :name="$t('form.pass1')" :validator="$v.form.pass1" style="margin-bottom: 8px !important;">
        <template slot-scope="{ attrs }">
          <v-text-field
            v-model="form.pass1"
            v-bind="{ ...attrs, errorMessages: attrs.errorMessages?.filter(msg => msg.includes('required')) }"
            :label="$t('form.pass1')"
            :append-icon="!showPassword ? 'mdi-eye-off' : 'mdi-eye'"
            :type="showPassword ? 'text' : 'password'"
            @click:append="showPassword = !showPassword"
            @input="$v.form.pass1.$touch()"
            @blur="$v.form.pass1.$touch()"
            autocomplete="off"
          />
        </template>
      </form-group>

      <PasswordRequirements :model-value="form.pass1" />

      <form-group :name="$t('form.pass2')" :validator="$v.form.pass2">
        <template slot-scope="{ attrs }">
          <v-text-field
            v-model="form.pass2"
            v-bind="attrs"
            :label="$t('form.pass2')"
            :append-icon="!showPassword2 ? 'mdi-eye-off' : 'mdi-eye'"
            :type="showPassword2 ? 'text' : 'password'"
            @click:append="showPassword2 = !showPassword2"
            @input="$v.form.pass2.$touch()"
            @blur="$v.form.pass2.$touch()"
            autocomplete="off"
          />
        </template>
      </form-group>
      <v-btn block color="primary btn-primary-custom" type="submit" class="mt-4" :loading="loading">{{ $t('save') }}</v-btn>
    </form>
  </AuthBox>
</template>

<script>
import { required, minLength, sameAs } from 'vuelidate/lib/validators';
import { hasNumber, hasSpecialChar, hasUppercase } from '@/validators/shared';
import FormGroup from '@/components/base/FormGroup';
import AuthBox from '@/components/base/AuthBox';
import PasswordRequirements from '@/components/PasswordRequirements.vue';

export default {
  name: 'AuthForgotPass',
  components: {
    AuthBox,
    FormGroup,
    PasswordRequirements
  },
  layout: 'empty',
  validations: {
    form: {
      pass1: { required, minLength: minLength(6), hasNumber, hasUppercase, hasSpecialChar },
      pass2: { required, sameAsPassword: sameAs('pass1') }
    }
  },
  data: () => ({
    form: {
      pass1: '',
      pass2: ''
    },
    loading: false,
    showPassword: false,
    showPassword2: false
  }),
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }

      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token');
      this.loading = true;
      this.$axios
        .post(`/api/auth/reset-password?token=${token}`, {
          password: this.form.pass1,
          confirmPassword: this.form.pass2
        })
        .then(() => this.$router.push({ name: 'AuthResetPassSuccess', replace: true }), localStorage.setItem('notif', 0))
        .finally(() => (this.loading = false));
    }
  },
  created() {
    this.$store.commit('Auth/SET_GOOGLE_AUTH_CLEAR');
  }
};
</script>
